module.exports = __webpack_public_path__ + "img/quote-office.d243750a.gif";